/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPaymentMethods } from '../fn/payment-methods/get-payment-methods';
import { GetPaymentMethods$Params } from '../fn/payment-methods/get-payment-methods';
import { PaymentMethodResponse } from '../models/payment-method-response';

@Injectable({ providedIn: 'root' })
export class PaymentMethodsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPaymentMethods()` */
  static readonly GetPaymentMethodsPath = '/payment-methods';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPaymentMethods()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaymentMethods$Response(params?: GetPaymentMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentMethodResponse>>> {
    return getPaymentMethods(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPaymentMethods$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaymentMethods(params?: GetPaymentMethods$Params, context?: HttpContext): Observable<Array<PaymentMethodResponse>> {
    return this.getPaymentMethods$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentMethodResponse>>): Array<PaymentMethodResponse> => r.body)
    );
  }

}
